import React, { CSSProperties } from 'react'
import styled from 'styled-components'

import { theme } from 'styled'
import { serviceLineMaterialIcon } from 'utils/serviceLineMaterialUtils'
import useAccount from 'hooks/useAccount'

const publicMaterialIcon = serviceLineMaterialIcon('Non-lead')
const privateMaterialIcon = serviceLineMaterialIcon('Galvanized')

const ServiceLineLegendIcon = () => {
  const { ptdSettings } = useAccount()
  const { systemOwnedName, customerOwnedName } = ptdSettings
  const systemMaterialLegendText = systemOwnedName
    ? systemOwnedName
    : 'System-Owned Material'

  const customerMaterialLegendText = customerOwnedName
    ? customerOwnedName
    : 'Customer-Owned Material'
  return (
    <SVGDiv>
      <svg height="22" style={svgStyle} viewBox="0 0 200 100" width="44">
        <rect fill="white" height="100" width="200" />
        <rect fill={theme.colors.primary} height="100" width="97" />
        <rect fill={'#F7685B'} height="100" width="97" x="103" />
        <path
          d={publicMaterialIcon}
          fill="white"
          style={{
            transform: `scale(.1) translate(${220}px, 240px)`
          }}
        />
        <path
          d={privateMaterialIcon}
          fill="white"
          style={{
            transform: `scale(.1) translate(${1420}px, 240px)`
          }}
        />
      </svg>
      <strong style={{ marginLeft: '7px', textAlign: 'left' }}>
        Service Line:
        <br />
        &emsp;Left Side = {systemMaterialLegendText}
        <br />
        &emsp;Right Side = {customerMaterialLegendText}
      </strong>
    </SVGDiv>
  )
}

const svgStyle: CSSProperties = {
  borderRadius: '4px'
}

const SVGDiv = styled.div`
  display: flex;
  align-items: center;
`

export default ServiceLineLegendIcon
